import { render } from "./Nav.vue?vue&type=template&id=14fa04fa&scoped=true"
import script from "./Nav.vue?vue&type=script&lang=js"
export * from "./Nav.vue?vue&type=script&lang=js"

import "./Nav.vue?vue&type=style&index=0&id=14fa04fa&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Desktop\\중요\\tcd-cube_opr\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14fa04fa"]])

export default __exports__